import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import '../Header.css'
import { CommonBaseURl } from '../../../Commonprovider/CommonProvider';
import { SetTopMenuNavigation } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice'
import { SetErrorStatus } from '../../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import { Set_TOP_NAVIGATION } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice';
import { Set_LEFT_MENU_NAVIGATION } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice'
import { Set_SUB_LEFT_MENU_NAVIGATION } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice'
import { SetLeftMenuTap, setLeftHeadMenu, setPageName } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice';
import { setselectedtab } from '../../../Redux/Slices/ScreenerRedux/CommonReduxSlices/ScreenerCommonSlice';
import { Logout, UserTypeValue, UserProductIDValue } from '../../../CommonFunction/Functions';
import { goToCompanyModule, goToTpScreenerModule, goToEMagazineModule } from '../../../CommonFunction/ModuleNavigation';
export const MobileHeader = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [BaseURL] = useState(CommonBaseURl)
    const Token = useSelector(state => state.Authenticationapi.token)
    const UserDetails = useSelector(state => state.LoginUserDetails.data)
    const TopNavigateTap = useSelector(state => state.Navigation.Topnavigate)
    const Peerset = useSelector((state) => state.LocalValuesData.PeersetData);
    const SeterrorStatusValue = useSelector(state => state.Navigation.ErrorStatus)
    const SelectedCompany = useSelector(state => state.LocalValuesData.SelectedCompany)
    const SelectedIndustry = useSelector(state => state.LocalValuesData.SelectedIndustry)
    const SelectedHouse = useSelector(state => state.LocalValuesData.SelectedHouse)
    const SelectedPeerset = useSelector(state => state.Screenercommon.PeersetName)
    const Landingpage = useSelector(state => state.Navigation.landingpage)
    const loginType = useSelector(state => state.LocalValuesData.loginType)
    const [TopNaviagateMenu, setTopNaviagateMenu] = useState([])
    const [ShowsettingPopup, setShowsettingPopup] = useState(false)
    const [ShowReachUsPopup, setShowReachUsPopup] = useState(false)
    const [ShowWhatsnewPopup, setShowWhatsnewPopup] = useState(false)
    const [changepPasswordPopup, setChangePasswordpopup] = useState(false)
    const Co_Code = useSelector(state => state.LocalValuesData.SelectedCompany[0]?.Co_Code)
    const ExportDetails = useSelector(state => state.LocalValuesData.ExportDetails)
    const Export = useSelector(state => state.LocalValuesData.Export)
    const Exported = useSelector(state => state.LocalValuesData.exported)
    const [UserGuidePopup, setUserGuidePopup] = useState(false);
    let lastURL = window.location.href
    const PageName = useSelector(state => state.Navigation.PageName)
    const userType = UserTypeValue()
    const productId = UserProductIDValue()

    // const NodeName = (Navigatename) => {
    //     if ((SelectedCompany !== '' && Navigatename != 'Live Application' && Navigatename != 'CM- Live News')) {
    //         switch (Navigatename) {
    //             case 'Home':
    //                 navigate('/Landing');
    //                 dispatch(SetErrorStatus(false));
    //                 break;
    //             case 'Company':
    //                 navigate('/Companyinfo');
    //                 dispatch(SetErrorStatus(false));
    //                 dispatch(SetLeftMenuTap(''))
    //                 dispatch(setLeftHeadMenu(''))
    //                 dispatch(Set_TOP_NAVIGATION(''))
    //                 dispatch(Set_LEFT_MENU_NAVIGATION(''))
    //                 dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
    //                 break;
    //             case 'Industry':
    //                 navigate(`/Industry/General/IndustryFactSheet`);
    //                 dispatch(SetErrorStatus(false));
    //                 dispatch(SetLeftMenuTap(''))
    //                 dispatch(setLeftHeadMenu(''))
    //                 dispatch(Set_TOP_NAVIGATION(''))
    //                 dispatch(Set_LEFT_MENU_NAVIGATION(''))
    //                 dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
    //                 break;
    //             case 'House':
    //                 navigate(`/House/General/HouseFactSheet`);
    //                 dispatch(SetErrorStatus(false));
    //                 dispatch(SetLeftMenuTap(''))
    //                 dispatch(setLeftHeadMenu(''))
    //                 dispatch(Set_TOP_NAVIGATION(''))
    //                 dispatch(Set_LEFT_MENU_NAVIGATION(''))
    //                 dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
    //                 break;
    //             case 'Peerset':
    //                 navigate(`/Peerset/Peerset/PeersetFactSheet`);
    //                 dispatch(SetErrorStatus(false));
    //                 dispatch(SetLeftMenuTap(''))
    //                 dispatch(setLeftHeadMenu(''))
    //                 dispatch(Set_TOP_NAVIGATION(''))
    //                 dispatch(Set_LEFT_MENU_NAVIGATION(''))
    //                 dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
    //                 break;
    //             case 'Ipo':
    //                 navigate(`Ipo/IPO/IpoIssuesOpen`);
    //                 break;
    //             case 'FactSheet':
    //                 navigate(`factSheet/Index`);
    //                 break;
    //             case 'Reports & Analytics':
    //                 navigate(`/reportsandanalytics/mffiidailyturnover/fiifpitradingactivity`)
    //                 break;
    //             case 'Live Application':
    //                 navigate(`/reportsandanalytics/mffiidailyturnover/fiifpitradingactivity`)
    //                 break;
    //             case 'CM- Live News':
    //                 navigate(`cmlivenews/cmlivenews/marketcommentary`);
    //                 break;
    //         }
    //     } else {
    //         dispatch(SetErrorStatus(true));
    //         navigate('/Landing');
    //     }

    // }




    const NodeName = (Navigatename) => {
        if ((SelectedCompany !== '' && Navigatename != 'Live Application' && SelectedIndustry !== '' && SelectedHouse !== '')) {
            switch (Navigatename) {
                case 'Home':
                    navigate('/Landing');
                    dispatch(SetErrorStatus(false));
                    break;
                case 'Company':
                    goToCompanyModule(dispatch, navigate);
                    break;
                case 'Industry':
                    navigate(`/Industry/General/IndustryFactSheet`);
                    dispatch(SetErrorStatus(false));
                    dispatch(SetLeftMenuTap(''))
                    dispatch(setLeftHeadMenu(''))
                    dispatch(Set_TOP_NAVIGATION(''))
                    dispatch(Set_LEFT_MENU_NAVIGATION(''))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
                    break;
                case 'House':
                    navigate(`/House/General/HouseFactSheet`);
                    dispatch(SetErrorStatus(false));
                    dispatch(SetLeftMenuTap(''))
                    dispatch(setLeftHeadMenu(''))
                    dispatch(Set_TOP_NAVIGATION(''))
                    dispatch(Set_LEFT_MENU_NAVIGATION(''))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
                    break;
                case 'Peerset':
                    navigate(`/Peerset/Peerset/PeersetFactSheet`);
                    dispatch(SetErrorStatus(false));
                    dispatch(SetLeftMenuTap(''))
                    dispatch(setLeftHeadMenu(''))
                    dispatch(Set_TOP_NAVIGATION(''))
                    dispatch(Set_LEFT_MENU_NAVIGATION(''))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
                    break;
                case 'Ipo':
                    navigate(`Ipo/IPO/IpoIssuesOpen`);

                    break;
                case 'FactSheet':
                    navigate(`factSheet/Index`);
                    break;
                case 'Reports & Analytics':
                    navigate(`/reportsandanalytics/mffiidailyturnover/fiifpitradingactivity`)

                    break;
                case 'Live Application':
                    navigate(`/reportsandanalytics/mffiidailyturnover/fiifpitradingactivity`)
                    break;
                case 'CM- Live News':
                    navigate(`cmlivenews/corporateevents/announcements`);
                    break;
                case 'Screener':
                    navigate(`/screener/domain`)
                    dispatch(setselectedtab('domain'))
                    break;
                case 'TP Screener': {
                    if (window.location.pathname && !window.location.pathname.startsWith('/tp-screener')) {
                        sessionStorage.setItem('main_app_last_url', window.location.pathname + window.location.search);
                        sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
                    }
                    goToTpScreenerModule(dispatch, navigate);
                    break;
                }
                case 'e-Magazine': {
                    if (window.location.pathname && !window.location.pathname.startsWith('/e-magazine')) {
                        sessionStorage.setItem('main_app_last_url', window.location.pathname + window.location.search);
                        sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
                    }
                    goToEMagazineModule(dispatch, navigate);
                    break;
                }
            }
        } else if (Navigatename == 'e-Magazine') {
            if (window.location.pathname && !window.location.pathname.startsWith('/e-magazine')) {
                sessionStorage.setItem('main_app_last_url', window.location.pathname + window.location.search);
                sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
            }
            goToEMagazineModule(dispatch, navigate);
        } else if (Navigatename == 'TP Screener') {
            if (window.location.pathname && !window.location.pathname.startsWith('/tp-screener')) {
                sessionStorage.setItem('main_app_last_url', window.location.pathname + window.location.search);
                sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
            }
            goToTpScreenerModule(dispatch, navigate);
        } else if (Navigatename == 'Screener') {
            dispatch(setselectedtab('domain'))
            navigate('/screener/domain');
        } else if (Navigatename == 'Reports & Analytics') {
            navigate(`/reportsandanalytics/mffiidailyturnover/fiifpitradingactivity`)
        }
        else if (Navigatename == 'FactSheet') {
            navigate(`factSheet/Index`);
        }
        else if (Navigatename == 'Ipo') {
            navigate(`Ipo/IPO/IpoIssuesOpen`);
        }
        else if (Navigatename == 'CM- Live News') {
            navigate(`cmlivenews/corporateevents/announcements`);
        }
        else {
            dispatch(SetErrorStatus(true));
            navigate('/Landing');
        }
    }

    useEffect(() => {
        let Userid = sessionStorage.getItem("getuserid");
        if (Token != null) {
            fetch(`${BaseURL}GetNavigateBarMENU?userid=${Userid}&SD_Active=${userType}`, {
                method: "GET",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    Authorization: "Bearer " + Token.access_token,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    let data1 = JSON.parse(data);
                    setTopNaviagateMenu(data1);
                });
        }
    }, [])
    return (
        <>
            <ul className='header-links mobile common-scroller common-horizontle-scroller'>
                {/* {TopNaviagateMenu && TopNaviagateMenu.map((data) => (
                    <li className={TopNavigateTap[1] == data.NODENAME ? "active" : ""} onClick={() => { dispatch(SetTopMenuNavigation([data.NODENAME == 'Home' ? TopNavigateTap[0] : data.Navigate_ID, data.NODENAME])); NodeName(data.NODENAME) }}>
                        <a>{data.NODENAME}</a>
                    </li>
                ))} */}

                {TopNaviagateMenu && TopNaviagateMenu.map((data) => (
                    data.NODENAME != 'CS' && data.NODENAME != 'Home' && (
                        <li className={
                            ((TopNavigateTap[1] === 'Home' && !Landingpage ? 'Company' : TopNavigateTap[1]) === data.NODENAME)
                                // ||(!Landingpage && data.NODENAME === 'Company')
                                ? "active"
                                : ""
                        } onClick={() => {
                            dispatch(SetTopMenuNavigation(data.NODENAME === 'Home'
                                ? [2, 'Home']
                                : [data.Navigate_ID, data.NODENAME])); NodeName(data.NODENAME)
                        }}>
                            <span>{data.NODENAME === 'Ipo' ? 'IPO' : data.NODENAME}</span>
                        </li>
                    )
                ))}

                {String(productId) === '4' && (
                    <li
                        className={TopNavigateTap[1] === 'e-Magazine' ? "active" : ""}
                        onClick={() => {
                            dispatch(SetTopMenuNavigation([99, 'e-Magazine']));
                            NodeName('e-Magazine');
                        }}
                    >
                        <span>e-Magazine</span>
                    </li>
                )}
            </ul>
        </>
    )
}
